import { useEffect, useState } from "react";
import { initGA4, readConsent, revokeGA4, writeConsent } from "@/lib/analytics";

const OPEN_EVENT = "aa:open-cookie-settings";

/** Programmatically reopen the banner (e.g. from a footer link). */
export const openCookieSettings = () => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(OPEN_EVENT));
};

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const existing = readConsent();
    if (!existing) {
      // Slight delay so the banner does not flash before paint.
      const t = window.setTimeout(() => setVisible(true), 600);
      return () => window.clearTimeout(t);
    }
    if (existing.analytics) {
      initGA4();
    }
  }, []);

  useEffect(() => {
    const open = () => setVisible(true);
    window.addEventListener(OPEN_EVENT, open);
    return () => window.removeEventListener(OPEN_EVENT, open);
  }, []);

  const accept = () => {
    writeConsent(true);
    initGA4();
    setVisible(false);
  };

  const reject = () => {
    writeConsent(false);
    revokeGA4();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie preferences"
      className="fixed bottom-4 left-4 right-4 sm:right-auto sm:max-w-md z-[100] rounded-xl border border-white/10 bg-[#0f0f0f]/95 backdrop-blur-xl p-5 shadow-2xl"
      style={{ boxShadow: "0 20px 60px -20px rgba(0, 229, 255, 0.15)" }}
    >
      <h2 className="text-sm font-semibold text-white mb-2">
        We use cookies for analytics
      </h2>
      <p className="text-xs text-white/70 leading-relaxed mb-4">
        We use a small set of analytics cookies (Google Analytics 4) to
        understand how visitors use the site. Nothing else. You can change
        your choice any time from the footer.
      </p>
      <div className="flex flex-col-reverse sm:flex-row gap-2">
        <button
          type="button"
          onClick={reject}
          className="flex-1 h-9 px-4 rounded-md border border-white/15 text-xs font-medium text-white/80 hover:text-white hover:border-white/30 transition-colors"
        >
          Reject
        </button>
        <button
          type="button"
          onClick={accept}
          className="flex-1 h-9 px-4 rounded-md bg-[#00e5ff] text-black text-xs font-semibold hover:bg-[#00d4e6] transition-colors"
        >
          Accept analytics
        </button>
      </div>
    </div>
  );
};
